import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import MeetingPointAddressModal from "../components/Modal/MeetingPointAddressModal";
import Navbar from "../components/Navbar";
import TourManagementOptionsSidebar from "../components/tour/TourManagementSidebarOptionsSidebar";
import CustomRadio from "../components/common/CustomRadio";
import { useDispatch, useSelector } from "react-redux";
import {
  setMeetingDifferentAddressModal,
  setMeetingPickupAreaModal,
  setMeetingPointAddressModal,
} from "../reducer/modalReducer";
import { Paths } from "../router/Paths";
import useOnLoadPage from "../hooks/useOnLoadPage";
import { RootState } from "../app/store";
import {
  setPacakgeMettingPointAddress,
  setEditedPickupIndex,
  setPackageData,
  setCheckAreaOrAddressModal,
  setPacakgeMettingDifferentAddress,
  setOptionsData,
} from "../reducer/tourReducer";
import { PiPackage } from "react-icons/pi";
import PickupAreaAddressModal from "../components/Modal/PickupAreaAddressModal";
import DifferentAddressModal from "../components/Modal/DifferentAddressModal";
import { useOptions } from "../hooks/useOptions";
import { resetOptionEdit } from "../reducer/tourEditReducer";

const arrivalOptions = [
  "Not relevant for this activity",
  "5 minutes before the activity",
  "10 minutes before the activity",
  "15 minutes before the activity",
  "20 minutes before the activity",
  "25 minutes before the activity",
  "30 minutes before the activity",
];
const pickupTimeOptions = [
  "You’ll pick them up at the time the activity starts",
  "The day before the activity takes place",
  "Within 24 hours after they book",
];

const pickupAddress = [
  "0-15 min before the activity starts",
  "0-30 min before the activity starts",
  "0-45 min before the activity starts",
  "0-1 hour before the activity starts",
  "0-1.5 hour before the activity starts",
  "0-2 hour before the activity starts",
];

const dropoffOptions: any = [
  "At the same place you met them",
  "At a different place",
  "No drop-off service, the customer stays at the site or destination",
];

const dropofTransportation = [
  "Bike",
  "Segway",
  "Electric bike",
  "Mountain bike",
  "Motorcycle",
  "Scotter",
  "Car",
  "Limousine",
  "Van",
  "Bus / coach",
  "Black cab",
  "Gondola",
  "Water taxi",
  "Other water transport",
  "Quad ATV",
  "Trike",
  "Tuk tuk",
];

function TourManagementPackageMeetingPage() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const { packageData, optionsData, packageId } = useSelector(
    (state: RootState) => state.tour
  );
  const {
    tourEdit,
    optionId,
    id: editPackageId,
  } = useSelector((state: RootState) => state.edit);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [editIndex, setEditIndex] = useState(null);
  const [currentLocation, setCurrentLocation] = useState(null);
  const [isActivedropAddress, setIsActivedropAddress] = useState<boolean>();
  const { PrepackageDataId } = useSelector((state: RootState) => state.tour);
  const { createPreOptions } = useOptions();
  const [loading, setLoading] = useState(false);
  const progressref = useRef(12);
  const [meetingAddress, setMeetingAddress] = useState<string>("");

  useEffect(() => {
    if (location.state && location.state.optionData) {
      dispatch(setOptionsData(location.state.optionData));
    }
  }, [location.state, dispatch]);

  useEffect(() => {
    // Initialize meetingAddress from optionsData
    setMeetingAddress(
      optionsData?.meetingPoint?.address || optionsData?.meetingAddress || ""
    );
  }, [optionsData?.meetingPoint?.address, optionsData?.meetingAddress]);

  const [editedMeetingSetting, setEditedMeetingSetting] = useState<string>(
    optionsData?.meetingSetting || ""
  );
  const [editedMeetingPointDescription, setEditedMeetingPointDescription] =
    useState<string>(optionsData?.meetingPointDescription || "");

  const [editedMeetingAddress, setEditedMeetingAddress] = useState<string>(
    optionsData?.meetingAddress || ""
  );
  const [editedArrivalTime, setEditedArrivalTime] = useState<string>(
    optionsData?.arrivalTime || ""
  );
  const [editedPickupService, setEditedPickupService] = useState<string>(
    optionsData?.pickupService || ""
  );
  const [editedPickupDescription, setEditedPickupDescription] =
    useState<string>(optionsData?.pickupDescription || "");
  const [editedPickupAreas, setEditedPickupAreas] = useState<string[]>(
    optionsData?.pickupAreas || []
  );
  const [editedPickupNotice, setEditedPickupNotice] = useState<string>(
    optionsData?.pickupNotice || ""
  );
  const [editedPickupTime, setEditedPickupTime] = useState<string>(
    optionsData?.pickupTime || ""
  );
  const [editedDropOff, setEditedDropOff] = useState<string>(
    optionsData?.dropOff || ""
  );
  const [editedDropOffAddress, setEditedDropOffAddress] = useState<string>(
    optionsData?.dropOffAddress || ""
  );

  const [editedDropOffTransportationType, setEditedDropOffTransportationType] =
    useState<string>(optionsData?.dropoffTransportationType || "");

  useEffect(() => {
    if (dropAddress === optionsData?.dropOff) {
      setIsActivedropAddress(true);
    } else {
      setIsActivedropAddress(false);
    }
  }, [optionsData?.dropOff]);

  const dropAddress = dropoffOptions[1];

  useOnLoadPage({ tabActive: "create" });

  const handleAddAddress = () => {
    dispatch(setMeetingPointAddressModal(true));
  };

  const handleEditAddress = () => {
    dispatch(setMeetingPointAddressModal(true));
  };

  const handleRemoveAddress = () => {
    setMeetingAddress("");
    dispatch(
      setOptionsData({
        ...optionsData,
        meetingPoint: null,
        meetingAddress: "",
      })
    );
  };

  const handleAddDifferenceAddress = () => {
    dispatch(setMeetingDifferentAddressModal(true));
  };

  const handlePickupArea = () => {
    dispatch(setMeetingPickupAreaModal(true));
    dispatch(setCheckAreaOrAddressModal("PickupArea"));
  };

  const handlePickupAddress = () => {
    dispatch(setMeetingPickupAreaModal(true));
    dispatch(setCheckAreaOrAddressModal("PickupAddress"));
  };

  const handleEditPickupArea = (index: any) => {
    dispatch(setMeetingPickupAreaModal(true));
    dispatch(setEditedPickupIndex(index));
    dispatch(setCheckAreaOrAddressModal("PickupArea"));
  };

  const handleEditPickupAddress = (index: any) => {
    dispatch(setMeetingPickupAreaModal(true));
    dispatch(setEditedPickupIndex(index));
    dispatch(setCheckAreaOrAddressModal("PickupAddress"));
  };

  const onContinue = () => {
    const isSelected = optionsData.meetingSetting !== undefined;
    console.log(optionsData);
    if (!isSelected) {
      setErrorMessage("Please select an option before continuing.");
      return;
    }
    setErrorMessage(null);

    navigate(Paths.tourManagementPackageOptionsConnectivity);
  };

  const onSave = async () => {
    const isSelected = optionsData.meetingSetting !== undefined;
    if (!isSelected) {
      setErrorMessage("Please select an option before continuing.");
      return;
    }
    setErrorMessage(null);

    const updatedPackageData = {
      ...optionsData,
      _id: optionsData._id,
      progress: Number(progressref.current),
      meetingSetting: optionsData?.meetingSetting,
      meetingAddress: meetingAddress, // use local state
      meetingPoint: meetingAddress
        ? { ...(optionsData.meetingPoint || {}), address: meetingAddress }
        : null,
      meetingPointDescription: optionsData?.meetingPointDescription,
    };

    const updatedPackageData2 = {
      ...optionsData,
      ...updatedPackageData,
    };

    setLoading(true);

    try {
      if (tourEdit) {
        dispatch(resetOptionEdit());
        dispatch(setOptionsData(updatedPackageData2));
        const pkgId = packageData._id;
        navigate(`/manage/product/${pkgId}/${optionId}`, {
          state: {
            fromEdit: true,
            option: updatedPackageData2,
            packageId: pkgId,
          },
        });
        return;
      } else {
        await createPreOptions(updatedPackageData);
      }
      navigate(Paths.welcome);
    } catch (error) {
      console.error("Error saving package:", error);
    } finally {
      setLoading(false);
    }
  };

  const MeetingAddress = () => {
    if (meetingAddress) {
      return (
        <div className="flex justify-between items-center border-b-2 border-t-2 py-3 mx-4">
          <span className="text-gray-900 text-lg  max-w-[120px] truncate">
            {meetingAddress}
          </span>
          <div className="flex gap-4">
            <button
              className="text-blue-800 font-bold text-lg"
              onClick={handleEditAddress}
            >
              Edit
            </button>
            <button
              className="text-red-500 font-bold text-lg"
              onClick={handleRemoveAddress}
            >
              Remove
            </button>
          </div>
        </div>
      );
    }
    return null;
  };

  const MeetingDifferentAddress = () => {
    const dispatch = useDispatch();
    const handleRemoveDifferentAddress = () => {
      dispatch(setPacakgeMettingDifferentAddress(null));
      dispatch(
        setPackageData({
          ...packageData,
          meetingPoint: {
            ...packageData.meetingPoint,
            dropOffAddress: null,
          },
        })
      );
    };

    if (packageData.meetingPoint?.dropOffAddress) {
      return (
        <div className="flex justify-between items-center border-b-2 border-t-2 py-3 mx-4">
          <span className="text-gray-900 text-lg max-w-[120px] truncate">
            {packageData.meetingPoint.dropOffAddress}
          </span>
          <div className="flex gap-4">
            <button
              className="text-blue-800 font-bold text-lg"
              onClick={handleAddDifferenceAddress}
            >
              Edit
            </button>
            <button
              className="text-red-500 font-bold text-lg"
              onClick={handleRemoveDifferentAddress}
            >
              Remove
            </button>
          </div>
        </div>
      );
    }

    return null;
  };
  console.log("address", optionsData.meetingPoint);
  console.log("dropof", optionsData?.dropOffAddress);

  const handleBack = () => {
    navigate(Paths.tourManagementPackageOptionsSetup);
  };

  return (
    <div className={Classname.container}>
      <MeetingPointAddressModal />
      <PickupAreaAddressModal />
      <DifferentAddressModal />
      <Navbar />
      <div className={Classname.content}>
        <TourManagementOptionsSidebar selected={2} />
        <div className={Classname.detail}>
          <div className={Classname.title}>Meeting point or pickup</div>
          <div className={Classname.title}>
            How do customers get to the activity?
          </div>
          <CustomRadio
            label="They go to a set meeting point"
            value={"meeting_point"}
            selected={editedMeetingSetting}
            onSelect={() => {
              setEditedMeetingSetting("meeting_point");
              dispatch(
                setOptionsData({
                  ...optionsData,
                  meetingSetting: "meeting_point",
                })
              );
            }}
          />
          <CustomRadio
            value={"specific_areas"}
            label="They can choose where you pick them up from certain areas or a list of places"
            selected={editedMeetingSetting}
            onSelect={() => {
              setEditedMeetingSetting("specific_areas");
              dispatch(
                setOptionsData({
                  ...optionsData,
                  meetingSetting: "specific_areas",
                })
              );
            }}
          />
          {optionsData?.meetingSetting === "meeting_point" && (
            <div className="lg:ml-10 lg:border-l-2 border-gray-300 h-full ">
              <p className="font-bold text-xl lg:text-2xl my-3">
                Meeting point
              </p>
              <p className="mx-5 my-6 font-bold">Add meeting point address</p>
              {meetingAddress ? (
                <MeetingAddress />
              ) : (
                <button
                  className={Classname.addressButton}
                  onClick={handleAddAddress}
                >
                  Add Address
                </button>
              )}
              <div className={Classname.title}>
                Describe the meeting point{" "}
                <span className={Classname.titleOptional}> (optional)</span>
              </div>
              <div className={Classname.description}>
                Is there a specific landmark to look out for? How will customers
                recognize the guide?
              </div>
              <textarea
                name=""
                id=""
                cols={30}
                rows={10}
                className={Classname.textarea}
                placeholder="Enter your details"
                value={optionsData.meetingPointDescription}
                onChange={(e) => {
                  setEditedMeetingPointDescription(e.target.value);
                  dispatch(
                    setOptionsData({
                      ...optionsData,
                      meetingPointDescription: e.target.value,
                    })
                  );
                }}
              />
              <div className={Classname.title}>
                When do customers need to arrive?
              </div>
              <div className={Classname.description}>
                Do customers need to arrive early to be ready for their activity
                - for example, to pick up tickets, paperwork, or equipment?
              </div>
              <div className="w-full mb-4">
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">Select</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    label="Select"
                    value={editedArrivalTime}
                    onChange={(e) => {
                      setEditedArrivalTime(e.target.value);
                      dispatch(
                        setOptionsData({
                          ...optionsData,
                          arrivalTime: e.target.value,
                        })
                      );
                    }}
                  >
                    {arrivalOptions.map((option, index) => (
                      <MenuItem value={option} key={index}>
                        {option}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </div>

              <h1 className="font-bold text-lg lg:text-xl">Drop-off</h1>
              <div className={Classname.title2}>
                Where will you drop off the customer at the end of the activity?
              </div>
              {dropoffOptions.map((option: any, index: any) => (
                <CustomRadio
                  key={index}
                  label={option}
                  value={option}
                  selected={editedDropOff}
                  onSelect={() => {
                    setEditedDropOff(option);
                    dispatch(
                      setOptionsData({
                        ...optionsData,
                        dropOff: option,
                      })
                    );
                  }}
                />
              ))}
            </div>
          )}

          {optionsData.meetingSetting === "specific_areas" && (
            <div className="lg:ml-10 lg:border-l-2 border-gray-300 h-full ">
              <p className="font-bold text-xl lg:text-2xl my-3">
                Pickup service
              </p>
              <div className={Classname.title2}>
                Where will you pick up customers? (We’ll tell you the customer’s
                pickup address).
              </div>
              <CustomRadio
                label="You’ll pick them up at any address in areas you specify."
                value={"any_address"}
                selected={editedPickupService}
                onSelect={() => {
                  setEditedPickupService("any_address");
                  dispatch(
                    setOptionsData({
                      ...optionsData,
                      pickupService: "any_address",
                    })
                  );
                }}
              />
              <CustomRadio
                label="You’ll pick them up at specific places like hotels, airports, etc. you list."
                value={"specific_place"}
                selected={editedPickupService}
                onSelect={() => {
                  setEditedPickupService("specific_place");
                  dispatch(
                    setOptionsData({
                      ...optionsData,
                      pickupService: "specific_place",
                    })
                  );
                }}
                className="my-6"
              />

              {optionsData.pickupService === "any_address" && (
                <div className="mt-5">
                  <div className="mt-4 space-y-3">
                    {optionsData?.meetingPoint?.pickupArea?.map(
                      (area, index: any) => {
                        return (
                          <div
                            key={index}
                            className="flex justify-between items-center  p-4 rounded border-b-2 border-t-2 mx-6 my-3"
                          >
                            <span className="text-black text-lg max-w-[120px] truncate">
                              {area}
                            </span>
                            <div className="flex space-x-3">
                              <button
                                className="text-blue-800 font-bold text-lg"
                                onClick={() => handleEditPickupArea(index)}
                              >
                                Edit
                              </button>
                              <button
                                className="text-red-500 font-bold text-lg"
                                onClick={() => {
                                  const updatedPickupArea =
                                    optionsData?.meetingPoint?.pickupArea?.filter(
                                      (item, idx) => idx !== index
                                    );
                                  dispatch(
                                    setOptionsData({
                                      ...optionsData,
                                      meetingPoint: {
                                        ...optionsData.meetingPoint,
                                        pickupArea: updatedPickupArea,
                                      },
                                    })
                                  );
                                }}
                              >
                                Remove
                              </button>
                            </div>
                          </div>
                        );
                      }
                    )}
                  </div>
                  <button
                    className={Classname.addressButton}
                    onClick={handlePickupArea}
                  >
                    Add area
                  </button>
                </div>
              )}

              <div>
                {optionsData.pickupService === "specific_place" && (
                  <div className="mt-5">
                    <div className="mt-4 space-y-3">
                      {optionsData.meetingPoint?.pickupAddress?.map(
                        (address, index: any) => {
                          return (
                            <div
                              key={index}
                              className="flex justify-between items-center  p-4 rounded border-b-2 border-t-2 mx-6 my-3"
                            >
                              <span className="text-black text-lg  max-w-[120px] truncate">
                                {address}
                              </span>
                              <div className="flex space-x-3">
                                <button
                                  className="text-blue-800 font-bold text-lg"
                                  onClick={() => handleEditPickupAddress(index)}
                                >
                                  Edit
                                </button>
                                <button
                                  className="text-red-500 font-bold text-lg"
                                  onClick={() => {
                                    const updatedPickupAddress =
                                      optionsData?.meetingPoint?.pickupAddress?.filter(
                                        (item, idx) => idx !== index
                                      );
                                    dispatch(
                                      setOptionsData({
                                        ...optionsData,
                                        meetingPoint: {
                                          ...optionsData.meetingPoint,
                                          pickupAddress: updatedPickupAddress,
                                        },
                                      })
                                    );
                                  }}
                                >
                                  Remove
                                </button>
                              </div>
                            </div>
                          );
                        }
                      )}
                    </div>
                    <button
                      className={Classname.addressButton}
                      onClick={handlePickupAddress}
                    >
                      Add address
                    </button>
                  </div>
                )}
              </div>
              <div className={Classname.title}>
                Describe your pickup{" "}
                <span className={Classname.titleOptional}> (optional)</span>
              </div>
              <div className={Classname.description}>
                What should customers look for when waiting for their vehicle?
                Where should they wait? If your pickup areas/places are very
                specific, describe them in more detail.
              </div>
              <textarea
                name=""
                id=""
                cols={30}
                rows={10}
                className={Classname.textarea}
                placeholder="Enter your details"
                value={editedPickupDescription}
                onChange={(e) => {
                  setEditedPickupDescription(e.target.value);
                  dispatch(
                    setOptionsData({
                      ...optionsData,
                      pickupDescription: e.target.value,
                    })
                  );
                }}
              />

              <div className={Classname.title}>
                When will you tell the customer what time you’ll pick them up?
              </div>
              {pickupTimeOptions.map((option, index) => (
                <CustomRadio
                  key={index}
                  label={option}
                  value={editedPickupTime}
                  selected={option}
                  onSelect={() => {
                    setEditedPickupTime(option);
                    dispatch(
                      setOptionsData({
                        ...optionsData,
                        pickupTime: option,
                      })
                    );
                  }}
                />
              ))}

              <div className={Classname.title}>
                When do you usually pickup your customer?
              </div>
              <div className="flex flex-1">
                <FormControl fullWidth>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={editedPickupNotice}
                    className="mt-2"
                    onChange={(e) => {
                      setEditedPickupNotice(e.target.value);
                      dispatch(
                        setOptionsData({
                          ...optionsData,
                          pickupNotice: e.target.value,
                        })
                      );
                    }}
                  >
                    {pickupAddress.map((pickup, index) => (
                      <MenuItem value={pickup} key={index}>
                        {pickup}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </div>

              <h1 className="font-bold text-lg lg:text-xl my-6">Drop-off</h1>
              <div>
                <div className={Classname.title2}>
                  Where will you drop off the customer at the end of the
                  activity?
                </div>
                {dropoffOptions.map((option: any, index: any) => (
                  <CustomRadio
                    key={index}
                    label={option}
                    value={option}
                    selected={editedDropOff}
                    onSelect={() => {
                      setEditedDropOff(option);
                      dispatch(
                        setOptionsData({
                          ...optionsData,
                          dropOff: option,
                        })
                      );
                    }}
                  />
                ))}
              </div>

              <div className={Classname.title}>Transportation</div>
              <div className={Classname.title2}>
                What's the transportation used for pickup and drop-off?
              </div>
              <div className="flex flex-1">
                <FormControl fullWidth>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={editedDropOffTransportationType}
                    className="mt-2"
                    onChange={(e) => {
                      setEditedDropOffTransportationType(e.target.value);
                      dispatch(
                        setOptionsData({
                          ...optionsData,
                          dropoffTransportationType: e.target.value,
                        })
                      );
                    }}
                  >
                    {dropofTransportation.map((pickup, index) => (
                      <MenuItem value={pickup} key={index}>
                        {pickup}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </div>
            </div>
          )}
          {errorMessage && <p className="text-red-600 mt-2">{errorMessage}</p>}

          {isActivedropAddress && (
            <div className="lg:border-l-2 border-gray-300 lg:ml-10">
              <div className="lg:ml-10 border-l-4 border-gray-300 h-full  ">
                <p className="mx-5 my-6 font-bold">Add drop-off address</p>
                {optionsData?.dropOffAddress ? (
                  <MeetingDifferentAddress />
                ) : (
                  <button
                    className={Classname.addressButton}
                    onClick={handleAddDifferenceAddress}
                  >
                    Add Address
                  </button>
                )}
              </div>
            </div>
          )}

          <div className="flex justify-between items-centers mt-10">
            <button className={Classname.saveButton2} onClick={handleBack}>
              Back
            </button>
            <div className={Classname.buttonsContainer}>
              <button
                className={Classname.saveButton}
                onClick={onSave}
                disabled={loading}
              >
                {loading ? "Please Wait..." : "Save and exit"}
              </button>
              {!tourEdit && (
                <button
                  className={Classname.continueButton}
                  onClick={onContinue}
                >
                  Continue
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TourManagementPackageMeetingPage;

const Classname = {
  container:
    "flex w-full min-h-screen relative bg-white flex-col items-center font-main",
  content:
    "flex flex-col lg:flex-row w-full max-w-7xl flex-1 pt-10 lg:pt-0 max-lg:px-4",
  detail: "flex flex-col py-10 lg:px-6 w-full",
  titleOptional: "text-sm text-gray-500 font-normal",
  title: "font-bold text-lg mt-4 mb-2",
  title2: "font-semibold lg:text-lg mt-4 mb-2",
  input: "flex w-full h-14 border border-gray-400 rounded-md px-4 mt-2",
  textarea:
    "flex w-full h-44 py-4 border border-gray-400 rounded-md px-4 mt-2 mb-6 ",
  description: "flex text-base mb-4 mt-2",
  buttonsContainer: "flex max-lg:justify-between gap-3 max-lg:w-full",
  addressButton:
    "font-bold w-fit flex items-center gap-2 cursor-pointer text-primary1 py-3 px-3 border-primary1 border rounded-lg mt-4 mx-5",
  saveButton:
    "h-12 px-6 flex items-center lg:justify-center font-bold text-gray-700 border border-gray-500 rounded-md",
  saveButton2:
    "h-12 px-6 flex items-center lg:justify-center font-bold text-gray-700 border border-gray-500 rounded-md max-lg:hidden",
  continueButton:
    "h-12 px-6 flex items-center justify-center text-white font-bold bg-primary1 rounded-md",
};
